// src/pages/PurchaseAccountLedger/PurchaseAccountLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPurchaseAccountLedger,
  fetchPurchaseAccounts,
} from "./PurchaseAccountLedgerThunk";

const initialState = {
  list: [],
  accounts: [],
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const purchaseAccountLedgerSlice = createSlice({
  name: "purchaseAccountLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseAccountLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPurchaseAccountLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPurchaseAccountLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchPurchaseAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload;
      });
  },
});

export const { setFilters } = purchaseAccountLedgerSlice.actions;
export default purchaseAccountLedgerSlice.reducer;
